<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createSpending') }}</h1>
      <div class="form-container">
        <SpendingForm @save="save"></SpendingForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import SpendingForm from '@/components/SpendingForm'

  export default {
    components: {
      DashboardLayout,
      SpendingForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Spending/create', {
          spending: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'spending'
            }
          })
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'createSpending'}
        ]
      }
    }
  }
</script>
